import { FaArrowDownLong } from 'react-icons/fa6'
import { useRequests } from '../../../api/hooks/use.request'
import { RepairWorkByHouse } from '../../../api/service/request.service'
import ScrollTopButtonComponent from '../../../components/ui/button.component/scroll.top.button.component'
import * as styled from './styled'

const parseAffectedStreets = (streetsString?: string) => {
  if (!streetsString) return [];
  return streetsString.split(';').map(item => {
    const [name, houses] = item.split(':');
    return {
      name: name?.trim(),
      houses: houses?.trim()
    };
  });
};

export const IncidentTable: React.FC<{ streetId?: number }> = ({ streetId }) => {
 const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } =
    useRequests({ streetId })

  const allRequests = data?.pages
  .flatMap(page => page.data ?? [])
  .filter((item): item is RepairWorkByHouse => item != null)
  ?? []

  if (isLoading) {
    return (
      <styled.LoaderWrapper>
        <styled.Spinner />
      </styled.LoaderWrapper>
    )
  }

  return (
    <styled.TableContainer>
      <styled.Header>
        <div>проблема/причина</div>
        <div>дата початку</div>
        <div>планована дата закінчення</div>
      </styled.Header>

      {allRequests.length === 0 ? (
        <styled.EmptyState>
          Ремонтних робіт не знайдено за цією адресою
        </styled.EmptyState>
      ) : (
        allRequests.map((item, index) => (
          <styled.Card key={`${item.houseNum}-${index}`}>
            <styled.CardMain
             $isEmergency={!!item.isEmergency} 
            >
              <div>
                <styled.Title>{item.problem}</styled.Title>
                <styled.RowText>{item.reason}</styled.RowText>
              </div>
              <div>
                <styled.MobileLabel>Дата початку:</styled.MobileLabel>
                <styled.RowText>{item.dateBeg}</styled.RowText>
              </div>
              <div>
                <styled.MobileLabel>Планована дата закінчення робіт:</styled.MobileLabel>
                <styled.RowText>{item.datePlan}</styled.RowText>
              </div>
            </styled.CardMain>

            <styled.DetailsArea>
              <styled.DetailBlock>
              <styled.Label>Адреса ремонтної роботи</styled.Label>
              <styled.Content>
                {parseAffectedStreets(item.affectedStreets).map((address, idx) => (
                  <div key={idx} style={{ marginBottom: '5px' }}>
                    <strong>{address.name}:</strong> <span>{address.houses}</span>
                  </div>
                ))}
                {!item.affectedStreets && item.streetName && (
                  <strong>{item.streetName}, буд. {item.houseNum}</strong>
                )}
              </styled.Content>
            </styled.DetailBlock>
              <styled.DetailBlock>
                <styled.Label>Примітка:</styled.Label>
                <styled.Content>{item.eventText || '—'}</styled.Content>
              </styled.DetailBlock>
              <styled.DetailBlock>
                <styled.Label>Виконавець:</styled.Label>
                <styled.Content>
                  <strong>{item.executor}</strong>
                </styled.Content>
              </styled.DetailBlock>
            </styled.DetailsArea>
          </styled.Card>
        ))
      )}

      {hasNextPage && (
        <styled.LoadMoreButton
          onClick={() => fetchNextPage()}
          disabled={isFetchingNextPage}
        >
          {isFetchingNextPage ? (
            'Завантаження...'
          ) : (
            <>Показати ще <FaArrowDownLong /></>
          )}
        </styled.LoadMoreButton>
      )}

      <ScrollTopButtonComponent />
    </styled.TableContainer>
  )
}
